var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C6.33165 13 6.17019 12.9331 6.05115 12.8141C5.93211 12.695 5.86523 12.5336 5.86523 12.3652V0.634766C5.86523 0.466415 5.93211 0.30496 6.05115 0.185919C6.17019 0.0668769 6.33165 0 6.5 0C6.66835 0 6.82981 0.0668769 6.94885 0.185919C7.06789 0.30496 7.13477 0.466415 7.13477 0.634766V12.3652C7.13477 12.5336 7.06789 12.695 6.94885 12.8141C6.82981 12.9331 6.66835 13 6.5 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3652 7.13672H0.634766C0.466415 7.13672 0.30496 7.06984 0.185919 6.9508C0.0668769 6.83176 0 6.6703 0 6.50195C0 6.3336 0.0668769 6.17215 0.185919 6.05311C0.30496 5.93406 0.466415 5.86719 0.634766 5.86719H12.3652C12.5336 5.86719 12.695 5.93406 12.8141 6.05311C12.9331 6.17215 13 6.3336 13 6.50195C13 6.6703 12.9331 6.83176 12.8141 6.9508C12.695 7.06984 12.5336 7.13672 12.3652 7.13672Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_1478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ee5ab537d2edb2389c78377cf6904efa.svg";
export { ForwardRef as ReactComponent };